var map = {
	"./3D-1.png": 3150,
	"./apparel-1.png": 5748,
	"./fashion-1.png": 159,
	"./ghost-1.png": 7920,
	"./jewelry-1.png": 9931,
	"./solution-1.png": 1629,
	"./solution-2-1.png": 3749,
	"./style-clients-1.png": 4219,
	"./try-on-1.png": 462
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6777;